/**
 * What you are allowed through, and what it takes.
 *
 * There is no key anywhere in this game and there never will be. A key is an
 * object: you find it, you have it, and from then on the door is open whatever
 * anybody thinks of you. That is a collectible, and it turns the whole standing
 * system into a lock you can walk past.
 *
 * Access is a *threshold* on standing instead. Management thinks well enough of
 * you that nobody questions you on the marble. Engineering has decided you are
 * one of theirs, so the shop is not locked to you any more. Both of those can
 * go away again on a bad shift, which a key cannot, and neither of them is
 * something you can pick up.
 *
 * Each entry names a zone or a barrier, the department whose opinion decides
 * it, and a **rung** — one of the four in `standing.js`, which are the only
 * thing standing unlocks anywhere. Not a number: four doors with four different
 * numbers on them is four things to learn and no rule to learn them by, and
 * from inside the game it reads as a door that opens at some point for some
 * reason. Three of these want the same thing of you, so they say so.
 */
export const ACCESS = {
  /**
   * The clubhouse takeover.
   *
   * Crossing the marble in a back of house uniform is the first rule the game
   * teaches and the one it is most annoying about. This is the way out of it:
   * get Management far enough on side and the lobby stops being somewhere you
   * are trespassing and starts being somewhere you work. It is the single
   * clearest thing good standing buys, it is worth the whole first chapter, and
   * one bad shift takes it away again.
   */
  'foh-lobby': {
    department: 'management',
    rung: 'warm',
    granted: 'Nobody looks twice at you out here any more.',
    withdrawn: 'You are back to being staff on the marble.',
  },

  /**
   * The manager's office. Higher, because it is his desk.
   */
  'restricted-office': {
    department: 'management',
    rung: 'trusted',
    granted: 'His door is not a problem for you now.',
    withdrawn: 'His door is a problem again.',
  },

  /**
   * The dock apron, which belongs to whoever is working it.
   */
  'restricted-apron': {
    department: 'valet',
    rung: 'warm',
    granted: 'The apron is yours to walk across.',
    withdrawn: 'Stay off the apron.',
  },

  /**
   * The walk-in. Kitchen's cold room, and Kitchen decide.
   *
   * Nowhere near the route the job runs on, which is the point: a threshold
   * across the corridor everybody has to use is not access, it is a toll, and
   * putting one on the near ballroom doors took twenty-nine minutes off a clean
   * shift on day one before the player had done anything to deserve it. This
   * one opens a room with nothing in it you need — and somewhere to stand that
   * nobody can see into, which is worth a great deal once anyone is looking.
   */
  'walkin-door': {
    department: 'kitchen',
    rung: 'warm',
    granted: 'Kitchen left the walk-in open for you.',
    withdrawn: 'The walk-in is shut to you again.',
  },
};

export const ACCESS_IDS = Object.keys(ACCESS);
